import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";
import type { Nurse } from "../utils/models";

export const useNurses = (departmentId?: string, activeOnDate?: string) => {
	return useQuery<Nurse[]>({
		queryKey: ["nurses", departmentId, activeOnDate],
		queryFn: async () => {
			const response = await backendService.getNurses(departmentId, activeOnDate);
			return response.data;
		},
		enabled: false,
	});
};
